import Splide from '@splidejs/splide';

export default function galleryCarouselText() {

    // console.log('Gallery Carousel initialized');

    const carousels = document.querySelectorAll('.gallery_carousel_with_texts');

    carousels.forEach(carousel => {
        
        const splideGallery = carousel.querySelector('.gallery_carousel_with_texts .splide');

        if (splideGallery) {

            const gallery = new Splide(splideGallery, {
                pagination: true,
                drag: true,
                perPage: 1,
                perMove: 1,
                type: 'fade',
                rewind: true,
                arrows: true,
            });

            gallery.mount();

        }
    });

}